/**
 * @generated SignedSource<<937a4f9c93690a8f0d2bf3b009ad4bb9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamScheduleHeader_team$data = {
  readonly color: string | null;
  readonly id: string;
  readonly name: string;
  readonly " $fragmentType": "TeamScheduleHeader_team";
};
export type TeamScheduleHeader_team$key = {
  readonly " $data"?: TeamScheduleHeader_team$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamScheduleHeader_team">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamScheduleHeader_team",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    }
  ],
  "type": "Team",
  "abstractKey": null
};

(node as any).hash = "0057344ab814ddcbaa507ff28bece46c";

export default node;
